export * from './tag';
import Tag from './tag';
export default Tag;
